
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { OrderFormValues } from './orderFormSchema';
import ContactFields from './form-sections/ContactFields';
import AddressFields from './form-sections/AddressFields';
import SubdomainField from './form-sections/SubdomainField';
import TermsAndPayment from './form-sections/TermsAndPayment';

interface BillingInfoFormProps {
  form: UseFormReturn<OrderFormValues>;
  isLoading: boolean;
  selectedCountry: string;
  requireSubdomain?: boolean;
}

const BillingInfoForm: React.FC<BillingInfoFormProps> = ({
  form,
  isLoading,
  selectedCountry,
  requireSubdomain = false,
}) => {
  const countryOptions = [
    { value: 'USA', label: 'United States' },
    { value: 'CAN', label: 'Canada' },
    { value: 'UK', label: 'United Kingdom' },
    { value: 'AUS', label: 'Australia' },
    { value: 'GER', label: 'Germany' },
    { value: 'FRA', label: 'France' }
  ];
  
  return (
    <div className="space-y-6">
      {/* Contact Information Section */}
      <ContactFields form={form} />

      {/* Billing Address Section */}
      <AddressFields 
        form={form} 
        selectedCountry={selectedCountry} 
        countryOptions={countryOptions}
      />

      {/* Subdomain Section */}
      {requireSubdomain && <SubdomainField form={form} />}

      {/* Terms and Payment Section */}
      <TermsAndPayment form={form} isLoading={isLoading} />
    </div>
  );
};

export default BillingInfoForm;
